import account from "./account";
import newChart from "./newChart"
import home from "./home"
export default{
    account,
    newChart,
    home
}